import React, { useEffect, useState } from 'react';
import { Grid, Box, Modal, Typography, Button, LinearProgress } from "@mui/material";
import { styles } from "./styles";
import CloseIcon from '@mui/icons-material/Close';
import { deleteRole } from 'apis/user';

interface DeleteRoleProps {
  title:string;
  popupText:string
  open: boolean;
  handlePopupClose: Function | any;
 }


const ErrorPopup: React.FC<DeleteRoleProps> = ({title,popupText, open, handlePopupClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState("");

  //console.log(role);

  const handleDeleteRole = async () => {
    /*setErr("");
    setIsLoading(true);
    if (role !== null) {
      let data = await deleteRole(role.id);
      if (data?.response?.data?.errorMessage) {
        setIsLoading(false);
        setErr(data.response.data.errorMessage);
        return
      }

      if (data) {
        setIsLoading(false);
        handleClose(false);
        getRoles();
      }

    } else {
      setIsLoading(false);
      handleClose(false);
    }*/
    //handleDelete(role);
    //handlePopupClose(false);
  }

  return (
    <Modal
      open={open}
      onClose={handlePopupClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <>
        <Box sx={styles.container}>
          {isLoading && <LinearProgress sx={{ margin: ".5rem 0" }} />}
          {err !== "" && <Typography sx={{ color: "red", fontSize: ".7rem" }}>{err}</Typography>}
          <Grid item xs={12} sx={styles.header}>
            <h2>{title}</h2>
            <CloseIcon onClick={() => handlePopupClose(false)} />
          </Grid>
          <Grid item xs={12}>
            <Typography>{popupText}</Typography>
          </Grid>

          <Grid item xs={12} sx={styles.buttonContainer}>
            <Button sx={styles.cancelButton} onClick={() => handlePopupClose(false)}>OK</Button>
          
          </Grid>
        </Box>
      </>
    </Modal>
  )
}

export default ErrorPopup;
